import * as React from 'react'
import {WithTranslation, withTranslation} from 'react-i18next'
import {ProjectTemplateSummary} from 'src/stores/templates-store'
import ProjectTemplateEditor, {EditorProps} from '../../../../components/project-template-editor';


interface InlineProjectTemplateEditorProps extends EditorProps, WithTranslation {
    value?: ProjectTemplateSummary[]
}


// Summary and Dto do not follow the same structure for the field projectTemplates.
class InlineProjectTemplateEditor extends React.Component<InlineProjectTemplateEditorProps> {

    render() {
        return (
            <ProjectTemplateEditor
                companyId={this.props.companyId}
                value={this.props.value?.map(t => t.id ?? t) as string[]}
                onChange={this.props.onChange}
            />
        )
    }
}


export default withTranslation()(InlineProjectTemplateEditor);